import { ApiUtil as api } from "@/utils/api.util.js";

export class InvoiceService {
	static URL = process.env.API_URL + process.env.API_VER;
	static RESOURCE = "/invoices/";

	static all(queryParams = {}) {
		return api.get(this.URL + this.RESOURCE, queryParams);
	}
	static save(queryParams = {}) {
		return api.post(this.URL + this.RESOURCE, queryParams);
	}
	static approved(id, queryParams = {}) {
		return api.post(this.URL + this.RESOURCE + 'approved/' + id, queryParams);
	}
	static orderSearch(queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + 'order-search', queryParams);
	}
	static invoiceFrom(queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + 'invoice-from', queryParams);
	}
	static saveBatch(queryParams = {}) {
		return api.post(this.URL + this.RESOURCE + 'save-batch', queryParams);
	}
}



// WEBPACK FOOTER //
// ./src/services/invoice.service.js